import { Link } from 'react-router-dom';
import { useState } from 'react';

const footerLinks = {
  navigation: [
    { to: '/', label: '首页' },
    { to: '/category/romance', label: '浪漫爱情' },
    { to: '/category/fantasy', label: '奇幻冒险' },
    { to: '/category/action', label: '热血动作' },
    { to: '/category/completed', label: '已完结' },
  ],
  support: [
    { to: '/about', label: '关于我们' },
    { to: '/about', label: '联系我们' },
    { to: '/about', label: '版权声明' },
    { to: '/about', label: '用户协议' },
    { to: '/about', label: '隐私政策' },
  ],
  social: [
    { label: '站内动态', icon: 'ri-notification-3-line' },
    { label: '微信公众号', icon: 'ri-wechat-line' },
    { label: '热门内容', icon: 'ri-fire-line' },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubscribe = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubmitted(true);
      return;
    }
    setSubmitted(true);
    setEmail('');
    setError('');
    form.reset();
  };

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <span className="font-heading text-2xl text-background-50">韩漫大全</span>
            <p className="mt-3 text-sm text-background-300 leading-relaxed">
              致力于为中文读者提供最全、最新、最优质的韩国漫画资源。无删减、高清画质、下拉式流畅阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-background-400 mb-4">快速导航</h4>
            <ul className="space-y-2">
              {footerLinks.navigation.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-background-200 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-background-400 mb-4">帮助中心</h4>
            <ul className="space-y-2">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-background-200 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-background-400 mb-4">订阅更新</h4>
            {submitted ? (
              <p className="text-sm text-accent-300">感谢订阅！我们会发送最新更新到您的邮箱。</p>
            ) : (
              <form onSubmit={handleSubscribe}>
                <input name="website_alt" type="text" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                <div className="flex">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="输入邮箱地址"
                    required
                    className="flex-1 px-4 py-2 bg-secondary-800 border border-secondary-700 rounded-l-lg text-sm text-background-50 placeholder-background-500 focus:outline-none focus:border-accent-400"
                  />
                  <button type="submit" className="px-4 py-2 bg-accent-500 text-background-50 rounded-r-lg hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap text-sm">
                    订阅
                  </button>
                </div>
                {error && <p className="text-xs text-accent-300 mt-2">{error}</p>}
              </form>
            )}
            <div className="flex gap-3 mt-4">
              {footerLinks.social.map((s) => (
                <a
                  key={s.label}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-background-300 hover:bg-accent-500 hover:text-background-50 transition-all duration-200"
                  aria-label={s.label}
                  rel="nofollow"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-background-500">
            &copy; 2026 韩漫大全. All rights reserved.
          </p>
          <p className="text-xs text-background-500">
            本站所有漫画资源仅供学习交流，版权归原作者所有
          </p>
        </div>
      </div>

      <div className="bg-secondary-950 py-8 overflow-hidden">
        <div className="text-[80px] md:text-[140px] font-heading text-secondary-800/30 text-center leading-none tracking-tighter select-none">
          MANHWA DAQUAN
        </div>
      </div>
    </footer>
  );
}
